import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import { entryVerifyStatus } from 'config/entryVerifyStatus';
import { error, system600, verifyPass } from 'Mui/styles/color';

function VerifyStatusLabel({ status = entryVerifyStatus.WAITING, style = {} }) {
    const isWait = status === entryVerifyStatus.WAITING;
    const isNotPass = status === entryVerifyStatus.NOT_PASS;
    const isPass = status === entryVerifyStatus.PASSED;

    return (
        <Typography
            variant="subtitle2"
            css={[
                basicStyle,
                isWait && waitStyle,
                isNotPass && warningStyle,
                isPass && passStyle,
                style
            ]}
        >
            {isWait && i18n.t('label.wait_for_verify')}
            {isNotPass && i18n.t('label.not_passed')}
            {isPass && i18n.t('label.passed')}
        </Typography>
    );
}

VerifyStatusLabel.propTypes = {
    status: PropTypes.number
};

export default VerifyStatusLabel;

const basicStyle = css`
    padding: 2px 6px;
    background-color: ${system600.color};
    border-radius: 4px;
    color: #fff;
    user-select: none;
    text-align: center;
`;

const waitStyle = css`
    background-color: ${system600.color};
`;

const warningStyle = css`
    background-color: ${error.color};
`;
const passStyle = css`
    background-color: ${verifyPass.color};
`;
